export default "__VITE_ASSET__DtHj9xjv__"